import { Route, Routes, Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "./lib/api";
import type { User } from "./types";
import { AppLayout } from "./components/AppLayout";
import LoginPage from "./routes/LoginPage";
import DashboardPage from "./routes/DashboardPage";
import StoresPage from "./routes/StoresPage";
import StoreDetailPage from "./routes/StoreDetailPage";
import IngredientsPage from "./routes/IngredientsPage";
import RecipesPage from "./routes/RecipesPage";
import RecipeDetailPage from "./routes/RecipeDetailPage";
import MealPlansPage from "./routes/MealPlansPage";
import MealPlanNewPage from "./routes/MealPlanNewPage";
import MealPlanDetailPage from "./routes/MealPlanDetailPage";
import ShoppingListPage from "./routes/ShoppingListPage";
import FridgePage from "./routes/FridgePage";
import FamilyPage from "./routes/FamilyPage";
import AcceptInvitePage from "./routes/AcceptInvitePage";

interface MeResponse {
  user: User | null;
}

export default function App() {
  const meQuery = useQuery({
    queryKey: ["me"],
    queryFn: () => api.get<MeResponse>("/api/auth/me"),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });

  if (meQuery.isLoading) {
    return (
      <div className="flex h-full items-center justify-center text-slate-500">
        Načítám…
      </div>
    );
  }

  const user = meQuery.data?.user;

  if (!user) {
    return (
      <Routes>
        <Route path="/rodina/pozvanka/:token" element={<AcceptInvitePage user={null} />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/rodina/pozvanka/:token" element={<AcceptInvitePage user={user} />} />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route element={<AppLayout user={user} />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/obchody" element={<StoresPage />} />
        <Route path="/obchody/:id" element={<StoreDetailPage />} />
        <Route path="/suroviny" element={<IngredientsPage />} />
        <Route path="/recepty" element={<RecipesPage />} />
        <Route path="/recepty/:id" element={<RecipeDetailPage />} />
        <Route path="/jidelnicky" element={<MealPlansPage />} />
        <Route path="/jidelnicky/novy" element={<MealPlanNewPage />} />
        <Route path="/jidelnicky/:id" element={<MealPlanDetailPage />} />
        <Route path="/jidelnicky/:id/nakup/:storeId" element={<ShoppingListPage />} />
        <Route path="/lednice" element={<FridgePage />} />
        <Route path="/rodina" element={<FamilyPage user={user} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
